import React, { useState } from "react";
import { Plus } from "react-feather";
import axios from "axios";
import { baseurl } from "../../../component/Baseurl";
import Swal from 'sweetalert2';

function AddTerminal() {
  const [showModal, setShowModal] = useState(false);
  const [terminalCode, setTerminalCode] = useState("");
  const [terminalName, setTerminalName] = useState("");

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleSubmit = async () => {
    try {
      const terminalDetails = {
        terminalCode,
        terminalName,
      };
      console.log("Sent data:", terminalDetails);

      // Send POST request to backend
      const response = await axios.post(`${baseurl}add-terminal`, terminalDetails);

      console.log("Response from backend:", response.data);

      // Show success alert with SweetAlert2 and reload the page
      Swal.fire({
        icon: 'success',
        title: 'Terminal Added Successfully!',
        text: 'The terminal has been added successfully.',
        confirmButtonText: 'OK',
      }).then(() => {
        window.location.reload();  // Reload the page after the user clicks OK
      });

      // Close modal and reset form
      setShowModal(false);
      setTerminalCode("");
      setTerminalName("");
    } catch (error) {
      console.error("Error adding terminal:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Something went wrong. Please try again.',
      });
    }
  };

  return (
    <>
      {/* Add Terminal Button */}
      <span className="btn3" onClick={handleOpenModal}>
        <Plus size={17} /> Add Terminal
      </span>

      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ display: "block", background: "rgba(0, 0, 0, 0.5)" }}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title">Add Terminal</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                  aria-label="Close"
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <form>
                  <div className="row g-1 text-start">
                    {/* Terminal Code */}
                    <div className="col-md-12">
                      <label className="text-dark mb-1 labelset2 font3">
                        Terminal Code
                      </label>
                      <input
                        type="text"
                        className="input1"
                        placeholder="Enter Terminal Code"
                        value={terminalCode}
                        onChange={(e) => setTerminalCode(e.target.value)}
                      />
                    </div>

                    {/* Terminal Full Name */}
                    <div className="col-md-12">
                      <label className="text-dark mb-1 labelset2 font3">
                        Terminal Full Name
                      </label>
                      <input
                        type="text"
                        className="input1"
                        placeholder="Enter Terminal Full Name"
                        value={terminalName}
                        onChange={(e) => setTerminalName(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="text-end">
                    <button
                      type="button"
                      className="submit-btn mt-3"
                      onClick={handleSubmit}
                    >
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddTerminal;
